module.exports = __webpack_public_path__ + "img/noData.42e18e5c.png";